import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseUserAcademies } from '@/api/responses/manage/userAcademies'

export namespace UserAcademiesApi {
  /**
   * 塾管理者一覧取得
   *
   * @param pageNumber ページ番号
   * @param count 取得件数
   * @param options オプション項目
   * @param options.academyId 塾ID
   * @param options.searchText 検索文字列
   * @returns 塾管理者一覧
   */
  export async function getUserAcademies(
    pageNumber: number,
    count: number,
    options?: {
      /** 塾ID */
      academyId?: number
      /** 検索文字列 */
      searchText?: string
    }
  ): Promise<ApiResponseUserAcademies> {
    const params = {
      pageNumber: pageNumber,
      count: count,
    }

    // 任意パラメータを設定
    if (options) {
      // お知らせタイプ
      if (options.academyId) {
        Object.assign(params, { academyId: options.academyId })
      }
      // ソート逆順フラグ(falseの場合も設定不要)
      if (options.searchText) {
        Object.assign(params, { searchText: options.searchText })
      }
    }

    return await ApiBase.get('manage/users/academies', params)
  }

  /**
   * 塾管理者ユーザ登録API
   *
   * @param nickname ニックネーム
   * @param password パスワード
   * @param academyId 塾ID
   */
  export async function createUserAcademy(nickname: string, password: string, academyId: number): Promise<void> {
    const params = {
      nickname: nickname,
      password: password,
      academyId: academyId,
    }
    await ApiBase.post('manage/users/academies', params)
  }

  /**
   * 塾管理者ユーザ情報更新API
   *
   * @param userId ユーザID
   * @param nickname ニックネーム
   */
  export async function updateUserAcademy(userId: number, nickname: string): Promise<void> {
    const params = {
      nickname: nickname,
    }
    await ApiBase.post(`manage/users/academies/${userId}`, params)
  }
}
